<template>
  <div class="w-full">
    <el-form :model="form" :label-position="labelPosition" :rules="rules" ref="form">
      <DeliveryMethodForm :form="form" />
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="submit('form')" :loading="adding">Save</el-button>
        <el-button @click="cancelCreate" type="info">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import DeliveryMethodForm from './_includes/DeliveryMethodForm.vue';

export default {
  name: 'NewDeliveryMethod',
  data() {
    return {
      adding: false,
      labelPosition: 'top',
      rules: this.$store.state.SettingsModule.DeliveryMethods.validate_form,
    };
  },
  components: {
    DeliveryMethodForm,
  },
  computed: {
    form() {
      return this.$store.state.SettingsModule.DeliveryMethods.new_delivery_method;
    },
  },
  mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
  },
  methods: {
    async cancelCreate() {
      this.$router.back();
    },
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          try {
            this.adding = true;
            await this.$store.dispatch('SettingsModule/DeliveryMethods/newDeliveryMethod', { delivery_method: this.form });
            this.$notify.success({
              title: 'Success',
              message: 'Delivery method successfully added',
            });
            await this.$router.push(`/ecommerce/settings/delivery-methods/${
              this.$store.state.SettingsModule.DeliveryMethods.delivery_method.id
            }/details`);
          } catch (e) {
            this.adding = false;
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
          this.adding = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
